// @flow

import { ModalTransition } from '@atlaskit/modal-dialog';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import SiteSelectorDialog from '@atlassian/mpac-site-selection';
import { MarketplaceAppPaymentModelValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import React from 'react';

import {
  ANALYTICS_CATEGORY_APP_LISTING,
  ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR,
  ANALYTICS_SUBJECT_ID_CTA,
  ANALYTICS_SUBJECT_ID_REQUEST_APP,
} from '../../../../../../../../analytics/Events';
import { STARGATE_BASE_PATH } from '../../../../../../../../constants';

import type { MarketplaceProduct, SelectedSiteAndProduct } from '@atlassian/mpac-site-selection';
import type { AppDetailsLink } from '@atlassian/mpac-types';
import type { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';

export type Props = {|
  appCompatibilities: MarketplaceProduct[],
  appKey: string,
  appName: string,
  paymentModel: MarketplaceAppPaymentModel,
  appDetailsLink: AppDetailsLink,
  installAppHrefResolver: SelectedSiteAndProduct => string,
  requestAppHrefResolver: SelectedSiteAndProduct => string,
  onClose: () => void,
  isOpen: boolean,
  loginRedirectPath: string,
|};

const SiteSelectorDialogWrapper = (props: Props) => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleSiteSelectorInstallClick = (
    isAppFree: boolean,
    event: SyntheticEvent<HTMLLinkElement>
  ) => {
    event.preventDefault();
    const { currentTarget } = event;
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      source: ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR,
      actionSubjectId: ANALYTICS_SUBJECT_ID_CTA,
      attributes: {
        eventContainer: ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR,
        hosting: 'cloud',
        label: 'Start Free Trial',
        source: ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR,
        category: ANALYTICS_CATEGORY_APP_LISTING,
      },
    });
    if (currentTarget instanceof HTMLAnchorElement) {
      window.location = currentTarget.href;
    }
  };

  const handleRequestAppClick = () => {
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_REQUEST_APP,
      source: ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR,
      attributes: {
        eventContainer: ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR,
        label: 'Request App',
        category: ANALYTICS_CATEGORY_APP_LISTING,
        hosting: 'cloud',
        source: ANALYTICS_EVENT_CONTAINER_SITE_SELECTOR,
      },
    });
  };

  return (
    <ModalTransition>
      {props.isOpen && (
        <SiteSelectorDialog
          appCompatibilities={props.appCompatibilities}
          stargateBaseUrl={STARGATE_BASE_PATH}
          installAppHrefResolver={props.installAppHrefResolver}
          requestAppHrefResolver={props.requestAppHrefResolver}
          loginHref={`/login?redirect=${encodeURIComponent(props.loginRedirectPath)}`}
          onClose={props.onClose}
          isFreeApp={props.paymentModel === MarketplaceAppPaymentModelValues.Free}
          onInstallClick={handleSiteSelectorInstallClick}
          onRequestAppClick={handleRequestAppClick}
        />
      )}
    </ModalTransition>
  );
};

export default SiteSelectorDialogWrapper;
